// ============================================================================
// PinRepere.jsx — Corelia UI v1.1
// Repère circulaire réutilisable — version inline / overlay
// Sans FormLayout
// Support variantes pastel via theme.buttons
// ============================================================================

import React from "react";
import theme from "../../../styles/theme";

const PinRepere = ({
  variant = "pastelBlue",
  letter = "S",
  size = 28,
  disabled = false,
  style = {},
}) => {
  const palette = theme.buttons?.[variant] || theme.buttons?.pastelBlue || {
    background: "#E8F2F6",
    color: "#1E5066",
    border: "#B7C6CC",
  };

  const disabledPalette = theme.buttons?.disabled || {
    background: "#E5E9EC",
    color: "#8AA0AA",
  };

  const baseStyle = {
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,

    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: "50%",
    boxSizing: "border-box",

    backgroundColor: "#ffffff",
    color: disabled ? disabledPalette.color : palette.color,
    border: `2px solid ${
      disabled ? disabledPalette.color : palette.border || palette.color
    }`,

    fontFamily:
      theme.typography?.button?.fontFamily ||
      theme?.fonts?.body ||
      "inherit",
    fontSize: theme.typography?.button?.fontSize || "0.74rem",
    fontWeight: 600,
    lineHeight: 1,
    letterSpacing: theme.typography?.button?.letterSpacing || "0.02em",
    textTransform: "uppercase",

    userSelect: "none",
    boxShadow: "none",

    ...style,
  };

  return (
    <div aria-hidden="true" style={baseStyle}>
      {String(letter || "").slice(0, 1).toUpperCase()}
    </div>
  );
};

export default PinRepere;